import { BlockEngine } from 'shared/express-interface/blocks-core/BlockEngine'
import { BlockEngineProvider } from 'shared/express-interface/blocks-core/BlockEngineContext'
import { ITaskBlock } from 'shared/express-interface/blocks-core/ITaskBlock'
import classes from './CustomInterfaceTaskUI.module.less'

export type CustomInterfaceTaskUiProps = {
    blockEngine: BlockEngine
    blocks: ITaskBlock[]
}

export const CustomInterfaceTaskUi = (props: CustomInterfaceTaskUiProps) => {
    return (
        <BlockEngineProvider blockEngine={props.blockEngine}>
            <div className={classes['container']} data-testid="interface-task-ui-wrapper">
                {props.blocks.map(block => {
                    const blockProps = block.getProps()
                    const isHidden = blockProps?.visibility === 'hidden'

                    return (
                        <div
                            key={block.id}
                            className={isHidden ? undefined : classes['blockWrapper']}
                        >
                            {block.getElement()?.element}
                        </div>
                    )
                })}
            </div>
        </BlockEngineProvider>
    )
}
